// ═══════════════════════════════════════════════════════════════
// ClearView CRM Member Helpers
// ═══════════════════════════════════════════════════════════════

/** Check if a member holds CFRE certification (manual flag or CSV import) */
export const isCfreHolder = (member) => {
  if (member.isCfre) return true;
  const value = (member.cfre || "").trim().toLowerCase();
  return (
    value === "yes" ||
    value === "cfre" ||
    value === "certified" ||
    value === "cfre certified"
  );
};

/** Generate a unique member ID */
export const generateMemberId = () =>
  `mbr-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;

/** Generate a unique contact log ID */
export const generateLogId = () =>
  `log-${Date.now()}-${Math.random().toString(36).substr(2, 4)}`;
